/**
 * SendGrid API Key patterns:
 *
 * SendGrid API keys are used for email delivery service authentication.
 *
 * Patterns:
 * 1. SendGrid API Key:
 *    - Starts with 'SG.'
 *    - Followed by alphanumeric characters and special chars
 *    - Contains two segments separated by dots
 *
 * Examples:
 * - `SG.1234567890abcdefghij.ABCDEFGHIJ1234567890abcdefghij1234567890abcdefghij`
 *
 * References:
 * - https://docs.sendgrid.com/ui/account-and-settings/api-keys
 * - https://docs.sendgrid.com/for-developers/sending-email/authentication
 */

export const sendgridApiKey =
  /(?<![A-Za-z])SG\.[A-Za-z0-9_-]{16,128}\.[A-Za-z0-9_-]{32,128}/;
